/**
 * Appka prevezme odkaz, s ktorým ju Chrome spustil (KOLO 215).
 *
 * Manifest má `launch_handler: focus-existing` — keď je okno appky otvorené,
 * Chrome ho iba dá dopredu a adresu odkazu pošle do `window.launchQueue`;
 * stránka sa neprenačíta. Koncept z Tandem Zostáv sa otvorí oknom „Nový
 * import" **nad** tým, čo je otvorené (rozpísaná zákazka ostane), iná
 * adresa je navigácia. Karte, ktorá odkaz odovzdala, appka potvrdí
 * prevzatie (`KANAL`) a tá sa zavrie.
 *
 * Okno appky si zároveň poznačí, že appka v tomto profile je — karta
 * prehliadača podľa toho vie, že má odkaz odovzdať (`OdkazDoAppky`).
 */
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { cielOdkazu, jeAppka, KANAL, zapamatajAppku } from "@/lib/otvorenieAppky";

interface LaunchParams {
  targetURL?: string;
}
interface LaunchQueue {
  setConsumer: (consumer: (params: LaunchParams) => void) => void;
}

export function usePrevzatieOdkazu(otvorKoncept: (konceptId: string) => void): void {
  const navigate = useNavigate();
  const otvor = useRef(otvorKoncept);
  otvor.current = otvorKoncept;
  const chod = useRef(navigate);
  chod.current = navigate;

  useEffect(() => {
    if (jeAppka()) zapamatajAppku();
    const fronta = (window as unknown as { launchQueue?: LaunchQueue }).launchQueue;
    if (!fronta || typeof fronta.setConsumer !== "function") return;
    fronta.setConsumer((params) => {
      if (!params?.targetURL) return;
      const ciel = cielOdkazu(params.targetURL, window.location.origin);
      if (!ciel) return;
      if ("koncept" in ciel) {
        otvor.current(ciel.koncept);
        if (typeof BroadcastChannel === "function") {
          const kanal = new BroadcastChannel(KANAL);
          kanal.postMessage({ prevzaty: ciel.koncept });
          kanal.close();
        }
        return;
      }
      const teraz = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      if (ciel.cesta !== teraz) chod.current(ciel.cesta);
    });
  }, []);
}
